const getUrlParameter = (name: string): string | null => {
  const match = new RegExp(`[?|&]${name}=([^&;]+?)(&|#|;|$)`).exec(window.location.search);
  return decodeURIComponent(((match && match[1]) || '').replace(/\+/g, '%20')) || null;
};

export default getUrlParameter;
